import ajax from "@/core/http-request";

//数据请求
export const supplierApi = {
    save(data){
        return ajax.post('/dev/supplier/save', data)
    },
    query(condition){
        return ajax.get('/dev/supplier/page', { params: condition })
    },
    queryList(condition){
        return ajax.get('/dev/supplier/list', { params: condition })
    },
    delete(ids){
        return ajax.post('/dev/supplier/del', ids)
    }
}